import Layout from '@/layout/index.vue'

const UsersRouterView = {
  render: (h: any) => h('router-view')
}

const MappingAdRolesRouterView = {
  render: (h: any) => h('router-view')
}

export const AccesSecuritateRoutes = {
  path: '/access-security',
  component: Layout,
  children: [
    {
      path: '',
      component: (): Promise<any> =>
        import('@/features/acces-securitate/views/index.vue'),
      name: 'AccesSecuritateRoute',
      meta: {
        title: 'AccesSecuritateRouteTitle',
        requiresAuth: true
      }
    },
    {
      path: 'users',
      component: UsersRouterView,
      children: [
        {
          path: '',
          component: (): Promise<any> =>
            import(
              /* webpackChunkName: "users-index" */
              '@/features/users/views/index.vue'
            ),
          name: 'UsersIndexRoute',
          meta: {
            title: 'UsersIndexRouteTitle',
            requiresAuth: true
          }
        },
        {
          path: 'create',
          component: (): Promise<any> =>
            import(
              /* webpackChunkName: "users-create" */
              '@/features/users/views/create.vue'
            ),
          name: 'UsersCreateRoute',
          meta: {
            title: 'UsersCreateRouteTitle',
            requiresAuth: true
          }
        },
        {
          path: 'view/:userId',
          component: (): Promise<any> =>
            import(
              /* webpackChunkName: "users-details" */
              '@/features/users/views/details.vue'
            ),
          name: 'UsersDetailsRoute',
          meta: {
            title: 'UsersDetailsRouteTitle',
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: 'mapping-ad-roles',
      component: MappingAdRolesRouterView,
      children: [
        {
          path: '',
          component: (): Promise<any> =>
            import(
              /* webpackChunkName: "mapping-ad-roles-index" */
              '@/features/mapping-ad-roles/views/index.vue'
            ),
          name: 'MappingAdRolesIndexRoute',
          meta: {
            title: 'MappingAdRolesIndexRouteTitle',
            requiresAuth: true
          }
        },
        {
          path: 'create',
          component: (): Promise<any> =>
            import(
              /* webpackChunkName: "mapping-ad-roles-create" */
              '@/features/mapping-ad-roles/views/create.vue'
            ),
          name: 'MappingAdRolesCreateRoute',
          meta: {
            title: 'MappingAdRolesCreateRouteTitle',
            requiresAuth: true
          }
        }
      ]
    }
  ]
}
